import { appUrl } from "@src/cloud-connect/feature-toggles/feature-toggles";
import {
  ClientConfigurationTypes,
  updateErrorsMqttModal,
  updateStateMqttModal,
} from "@src/reducers/your-reducer";
import navigateTo from "@src/routes/navigator";
import { Route } from "@src/routes/routes";
import store from "@src/reducers/store";
import MqttConnectionTestUnsuccessfulError from "../errors/mqtt-connection-test-unsuccessful-error";
import TokensExpiredError from "../errors/tokens-expired-error";
import { buildAuthenticationBody } from "../util/build-authentication-body";
import { buildAuthenticationHeaders } from "../util/build-authentication-headers";

interface UpdateClientConfigurationDtoTypes {
  accessToken: string;
  clientId: string;
  namespace: string;
  data: ClientConfigurationTypes;
}

export const updateClientConfiguration = (
  dto: UpdateClientConfigurationDtoTypes,
) => {
  return fetch(`${appUrl()}/api/update-client-configuration`, {
    method: "POST",
    headers: buildAuthenticationHeaders(),
    body: JSON.stringify({ ...buildAuthenticationBody(), ...dto }),
  })
    .then(async (res) => {
      if (res.ok) {
        const json = await res.json();

        if (json.successful === false) {
          throw new MqttConnectionTestUnsuccessfulError(
            "unsuccessful",
            json.error_messages,
          );
        }

        return json;
      } else {
        const json = await res.json();
        if (json.message === "Refresh Token is expired") {
          throw new TokensExpiredError("All Tokens Expired");
        } else {
          throw new Error("Server Responded with 500");
        }
      }
    })
    .then((data) => {
      if (data !== undefined) {
        store.dispatch(updateStateMqttModal("mqtt-successful-connection"));
      }
    })
    .catch((err) => {
      if (err instanceof TokensExpiredError) {
        navigateTo(Route.TOKENS_EXPIRED_ERROR);
      } else if (err instanceof MqttConnectionTestUnsuccessfulError) {
        // error in den store schreiben
        store.dispatch(updateErrorsMqttModal(err.error_messages));
        // state des modals ändern
        store.dispatch(updateStateMqttModal("mqtt-unsuccessful-connection"));
      } else {
        navigateTo(Route.SERVER_ERROR);
      }
    });
};
